import React, { useEffect, useState } from 'react';
import { Typography, Spin, Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PageContainer } from './styles/SubscriptionsPage.styles';
import apiService from '@/services/api.service';
import { API_ENDPOINTS } from '@/constants/api.constants';

/**
 * Страница возврата после оплаты подписки на ЮKassa.
 * ЮKassa редиректит сюда по return_url после оплаты.
 * Проверяем сессию (cookie должны отправляться при SameSite=Lax на том же домене).
 */
const SubscriptionReturnPage: React.FC = () => {
    const navigate = useNavigate();
    const [status, setStatus] = useState<'checking' | 'ok' | 'logged_out'>('checking');

    useEffect(() => {
        let cancelled = false;

        const checkAndRedirect = async () => {
            try {
                // Сначала синхронизируем статус оплаты с ЮKassa (на случай, если webhook ещё не пришёл)
                try {
                    await apiService.get(API_ENDPOINTS.SUBSCRIPTIONS.SYNC_AFTER_PAYMENT);
                } catch {
                    // Игнорируем (например, не авторизован — проверим ниже)
                }
                // Проверка сессии и редирект
                await apiService.get(API_ENDPOINTS.USERS.ME);
                if (!cancelled) {
                    setStatus('ok');
                    setTimeout(() => navigate('/subscriptions', { replace: true }), 1500);
                }
            } catch {
                if (!cancelled) setStatus('logged_out');
            }
        };

        checkAndRedirect();
        return () => { cancelled = true; };
    }, [navigate]);

    if (status === 'checking') {
        return (
            <PageContainer>
                <Result
                    status="info"
                    title="Возврат после оплаты"
                    subTitle="Проверяем результат оплаты и статус подписки..."
                    extra={<Spin size="large" />}
                />
            </PageContainer>
        );
    }

    if (status === 'logged_out') {
        return (
            <PageContainer>
                <Result
                    status="warning"
                    title="Сессия истекла"
                    subTitle="После перехода на страницу оплаты сессия была прервана. Войдите в аккаунт — подписка будет в разделе «Мои подписки», если оплата прошла успешно."
                    extra={
                        <Button type="primary" onClick={() => navigate('/login')}>
                            Войти
                        </Button>
                    }
                />
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <Typography.Paragraph>Перенаправление в раздел подписок...</Typography.Paragraph>
            <Spin />
        </PageContainer>
    );
};

export default SubscriptionReturnPage;
